import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { push } from "store/actions/router";
import { FiUsers } from "react-icons/fi";
import { get } from "lodash";
import {
  hasAddedDeductionCode,
  hasAddedGroups,
  hasAnnouncedIcon,
  hasEnabled360PayrollIntegration,
  hasEnabledPayrollIntegration,
  hasInvitedEmployees,
  hasLaunchedPlan,
  hasStatePlanSelector,
  hasSuccessfullyConnectedPayroll,
} from "store/selectors/employer";
import type { RootState } from "types/state";

import Accordian from "./Accordian";

const nonPayrollIntegrationSteps = [
  {
    index: 1,
    label: "Announce Plan",
  },
  {
    index: 2,
    label: "Invite Employees",
  },
  {
    index: 3,
    label: "Launch Plan",
  },
];

const payrollIntegrationSteps = [
  {
    index: 1,
    label: "Announce Plan",
  },

  {
    index: 3,
    label: "Launch Plan",
  },
];

const mapStateToProps = (state: RootState) => {
  const { user } = state;
  return {
    user,
    hasStatePlan: hasStatePlanSelector(state),
    hasAnnouncedIcon: hasAnnouncedIcon(state),
    hasInvitedEmployees: hasInvitedEmployees(state),
    hasLaunchedPlan: hasLaunchedPlan(state),
    hasPayrollIntegration: hasEnabledPayrollIntegration(state),
    hasSuccessfullyConnectedPayroll: hasSuccessfullyConnectedPayroll(state),
    has360PayrollIntegration: hasEnabled360PayrollIntegration(state),
    hasAddedGroups: hasAddedGroups(state),
    hasAddedDeductionCode: hasAddedDeductionCode(state),
    // PRESERVED QUIRK: EmployerState has no `progressiveOnboarding` key (it
    // lives under `employer.company.progressiveOnboardingState`), so this read
    // is `undefined` at runtime and `employer` resolves to undefined. The
    // `employer` prop is never consumed by the component. Faithfully kept; the
    // cast only exposes the (absent) optional key without changing the value.
    employer: get(
      (state.employer as { progressiveOnboarding?: unknown })
        .progressiveOnboarding,
      "hasLaunchedPlan"
    ),
  };
};

const mapDispatchToProps = {
  push,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  onStepChange?: () => void;
  activeStepNumber?: number;
}

type Props = WithApolloClient<OwnProps> & PropsFromRedux;

class AddUsersCard extends React.PureComponent<Props> {
  _label = () => {
    let label;
    if (
      this.props.hasAddedGroups &&
      this.props.hasAddedDeductionCode &&
      !this.props.hasAnnouncedIcon
    ) {
      label = "Announce Plan";
    } else if (
      this.props.hasAddedGroups &&
      this.props.hasAddedDeductionCode &&
      this.props.hasAnnouncedIcon &&
      !this.props.hasInvitedEmployees
    ) {
      label = "Create List";
    } else if (
      this.props.hasInvitedEmployees &&
      this.props.hasAddedDeductionCode &&
      !this.props.hasLaunchedPlan
    ) {
      label = "Launch Plan";
    }
    return label;
  };

  render() {
    const label = this._label();

    const steps = this.props.hasPayrollIntegration
      ? payrollIntegrationSteps
      : nonPayrollIntegrationSteps;

    const waitingForRosterApproval =
      this.props.has360PayrollIntegration &&
      !this.props.hasSuccessfullyConnectedPayroll;
    return (
      <Accordian
        onClick={this.props.onStepChange}
        icon={<FiUsers color="white" stroke="#60A4BF" size={16} />}
        title={"Invite Employees"}
        description={"Add employee emails and invite them to enroll."}
        actionText={label}
        disabled={
          !this.props.hasAddedDeductionCode ||
          !this.props.hasAddedGroups ||
          waitingForRosterApproval
        }
        completedAction={this.props.hasLaunchedPlan}
        steps={steps}
        activeStepNumber={this.props.activeStepNumber}
      />
    );
  }
}

export default connector(withApollo<Props>(AddUsersCard));
